import {UIElement} from "./ui";
import {MapPosition} from "../../map/tools/coordinates";
import {WGS84_CODE} from "../config/config";
import {createStringXY} from "ol/coordinate";
import {ScaleLine} from "ol/control";
import '/modules/map/css/tools/coordinates-tool.css';
import '/modules/map/css/tools/coordinates-tool.responsive.css';

/**
 * A simple coordinate UI element
 * @extends UIElement
 */
class SimpleCoordinatesUIElement extends UIElement {

    /**
     *
     * @param projection {Projection} The map projection
     * @param controlsDOMElement {jQuery} The controls DOM element
     * @param overlayDOMElement {jQuery} The map overlay DOM element
     */
    constructor(projection, controlsDOMElement, overlayDOMElement) {
        super('ID_SimpleCoordinatesUIElement');
        this.projection = projection;
        this.controlsDOMElement = controlsDOMElement;

        this.mapPosition = new MapPosition({
            coordinateFormat: this.formatFunction(),
            projection: WGS84_CODE,
            target: $('.position-container', this.getUIElement())[0]
        }, this.controlsDOMElement, overlayDOMElement);
    }

    getClassName() {
        return "SimpleCoordinatesUIElement";
    }

    /**
     * Returns a function to format coordinates
     * @return {function(Array<number>): string}
     */
    formatFunction() {
        const stringify = createStringXY(4);
        return function (coords) {
            return "lon, lat: " + stringify(coords);
        }
    }

    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $('<div class="coordinates ol-unselectable ol-control"></div>');

            let projectionContainer = $('<div class="projection-container"><div>' + this.projection.getName() + '</div></div>');
            this.uiElement.append(projectionContainer);

            let positionContainer = $('<div class="position-container"></div>');
            this.uiElement.append(positionContainer);
        }
        return this.uiElement;
    }

    getOLControls() {
        let uiElement = this.getUIElement();
        if (!this.olControls) {
            this.olControls = [
                new ScaleLine({
                    units: 'metric',
                    target: uiElement[0]
                }),
                this.mapPosition
            ];
        }
        return this.olControls;
    }

    onNavigation(zoomLevel, centerWgs84) {
        if (this.mapPosition) {
            this.mapPosition.onNavigation(zoomLevel, centerWgs84);
        }
    }

    /**
     * Show the crosshair in the center of the view
     */
    showCrosshair() {
        this.mapPosition.showCrosshair();
        this.mapPosition.updateCoordinatesFromCenter();
    }

    /**
     * Hide the crosshair
     */
    hideCrosshair() {
        this.mapPosition.hideCrosshair();
    }

    /**
     * Is the crosshair visible?
     */
    isCrosshair() {
        return this.mapPosition.isCrosshair();
    }

}

export {SimpleCoordinatesUIElement}